import React, { useCallback, useMemo, useState } from 'react';
import * as FaIcons from 'react-icons/fa';
import * as FiIcons from 'react-icons/fi';
import { DateTime } from 'luxon';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import { parseMarkdown } from '../../helpers/markdown';
import { useHistory } from 'react-router-dom';
import NotificationToggle from '../NotificationToggle';

const NotificationRow = ({ notification: notificationData, markRead, markUnread, onAfterLinkClick = link => {} }) => {
  const history = useHistory();
  let link = null;
  let customClasses = 'text-guardian-darkblue';
  const [notification, setNotification] = useState(notificationData);
  const [loading, setLoading] = useState(false);
  const content = useMemo(() => parseMarkdown(notification.message), [notification.message]);
  // const content = parseMarkdown(notification.message);
  // const [isRead, setIsRead] = useState(notification.readAt || false);
  const isRead = !!notification.readAt || false;
  const readClass = isRead ? 'bg-white' : 'hover:bg-gray-100 rounded-lg bg-blue-100';
  // const toggleRead = useCallback(() => {
  //   // This function can be used to mark the notification as read
  //   // if needed, but currently, it is handled by the NotificationToggle component.
  //   console.log(`Marking notification ${notification.id} as read`);
  //   setIsRead(new Date().toISOString());
  // }, []);

  // const unRead = useCallback(() => {
  //   // This function can be used to mark the notification as unread
  //   // if needed, but currently, it is handled by the NotificationToggle component.
  //   console.log(`Marking notification ${notification.id} as unread`);
  //   setIsRead(false);
  // }, []);

  const getIcon = () => {
    switch (notification.type) {
      case 'CASE_SUBMITTED':
        return <FaIcons.FaBriefcaseMedical size="40" />;
      case 'CASE_SUBMITTED_AFTER_RETURN':
      case 'CASE_RESUBMITTED':
        // return <FaIcons.FaBriefcaseMedical size="40" />;
        return (
          <FontAwesomeIcon
            fontSize={40}
            mask={icon({ name: 'briefcase-blank', style: 'solid' })}
            icon={icon({ name: 'rotate', style: 'solid' })}
            transform="shrink-9 down-1 flip-h"
            // mask="fa-solid fa-circle"
          />
        );

      case 'CASE_APPROVED':
        return <FaIcons.FaAward size="40" />;

      case 'CASE_RETURNED':
        return <FaIcons.FaThumbsDown size="40" />;

      case 'CASE_ASSIGNED':
        return <FaIcons.FaBriefcase size="40" />;

      case 'CASE_UNASSIGNED':
        return <FaIcons.FaBriefcase size="40" />;

      case 'CASE_NULLIFIED':
      case 'CASE_DELETED':
        return (
          <span className="fa-layers fa-fw fa-3x">
            {/* <FaIcons.FaEnvelope size={20} /> */}
            <FontAwesomeIcon icon={icon({ name: 'trash-can', style: 'regular' })} />
          </span>
        );

      case 'CERTIFICATION_SUBMITTED':
        return <FaIcons.FaUser size="40" />;

      case 'STAFF_MESSAGE':
        return (
          <span className="fa-layers fa-fw fa-3x">
            <FontAwesomeIcon icon={icon({ name: 'message', style: 'regular' })} />
            <FontAwesomeIcon
              icon={icon({ name: 'triangle-exclamation', style: 'solid' })}
              transform={'shrink-5 up-7 right-7'}
              // mask={icon({ name: 'triangle', style: 'solid' })}
            />
          </span>
        );

      case 'MESSAGE_RECEIVED':
        return (
          <span className="fa-layers fa-fw fa-3x">
            {/* <FaIcons.FaEnvelope size={20} /> */}
            <FontAwesomeIcon icon={icon({ name: 'envelope', style: 'solid' })} />
          </span>
        );

      case 'CASE_FILE_DOWNLOADED':
        return (
          <span className="fa-layers fa-fw fa-3x">
            <FontAwesomeIcon icon={icon({ name: 'arrow-down-to-bracket', style: 'light', family: 'sharp' })} />
          </span>
        );

      case 'AWARD_THRESHOLD_REACHED':
        return <FontAwesomeIcon icon={icon({ name: 'trophy', style: 'solid' })} fontSize={40} />;

      case 'LEO_USER_ONBOARDED':
        // return <FontAwesomeIcon icon={icon({ name: 'user-police', style: 'solid' })} fontSize={40} />;
        return (
          <span className="fa-layers fa-fw fa-3x">
            <FontAwesomeIcon icon={icon({ name: 'user-police', style: 'solid' })} fontSize={40} transform={'left-2'} />
            <FontAwesomeIcon
              icon={icon({ name: 'plus', style: 'solid', family: 'sharp' })}
              transform={'shrink-10 right-6'}
              // mask={icon({ name: 'triangle', style: 'solid' })}
            />
          </span>
        );

      case 'USER_ONBOARDED':
        // return <FontAwesomeIcon icon={icon({ name: 'user-police', style: 'solid' })} fontSize={40} />;
        return (
          <span className="fa-layers fa-fw fa-3x">
            <FontAwesomeIcon icon={icon({ name: 'user', style: 'solid' })} fontSize={40} transform={'left-2'} />
            <FontAwesomeIcon
              icon={icon({ name: 'plus', style: 'solid', family: 'sharp' })}
              transform={'shrink-10 right-6'}
              // mask={icon({ name: 'triangle', style: 'solid' })}
            />
          </span>
        );

      case 'USER_DISABLED':
        return (
          <span className="fa-layers fa-fw fa-3x">
            <FontAwesomeIcon icon={icon({ name: 'user', style: 'solid' })} fontSize={40} transform={'left-2'} />
            <FontAwesomeIcon
              icon={icon({ name: 'pause', style: 'solid', family: 'sharp' })}
              transform={'shrink-10 right-6'}
              // mask={icon({ name: 'triangle', style: 'solid' })}
            />
          </span>
        );

      case 'USER_DELETED':
        return (
          <span className="fa-layers fa-fw fa-3x">
            <FontAwesomeIcon icon={icon({ name: 'user', style: 'solid' })} fontSize={40} transform={'left-2'} />
            <FontAwesomeIcon
              icon={icon({ name: 'trash-can', style: 'regular' })}
              transform={'shrink-10 right-6'}
              // mask={icon({ name: 'triangle', style: 'solid' })}
            />
          </span>
        );

      case 'LEO_USER_DISABLED':
        return (
          <span className="fa-layers fa-fw fa-3x">
            <FontAwesomeIcon icon={icon({ name: 'user-police', style: 'solid' })} fontSize={40} transform={'left-2'} />
            <FontAwesomeIcon
              icon={icon({ name: 'pause', style: 'solid', family: 'sharp' })}
              transform={'shrink-10 right-6'}
              // mask={icon({ name: 'triangle', style: 'solid' })}
            />
          </span>
        );

      case 'LEO_USER_DELETED':
        return (
          <span className="fa-layers fa-fw fa-3x">
            <FontAwesomeIcon icon={icon({ name: 'user-police', style: 'solid' })} fontSize={40} transform={'left-2'} />
            <FontAwesomeIcon
              icon={icon({ name: 'trash-can', style: 'regular' })}
              transform={'shrink-10 right-6'}
              // mask={icon({ name: 'triangle', style: 'solid' })}
            />
          </span>
        );

      default:
        return <FiIcons.FiMessageSquare size="40" />;
    }
  };

  // if (notification.type === 'MESSAGE_RECEIVED') {
  const matches = content.match(/href="([^"]*)/);
  if (Array.isArray(matches)) {
    link = matches[1];
  }
  // }

  if (notification.type === 'LEO_USER_ONBOARDED') {
    // customClasses = 'bg-pursuit-darkred text-white';
  }

  const getNotificationTime = () => {
    const luxonDate = DateTime.fromISO(notification.createdAt);

    return luxonDate.toFormat('ff');
  };

  const onClick = async e => {
    // toggleRead();
    e.preventDefault();
    if (!isRead) {
      // console.log('Marking notification as read:', notification.id);
      setLoading(true);
      await markRead();
      setLoading(false);
      // setNotification(update);
    }
    // console.log('Notification clicked:', { notification, link, e });
    // If the notification has a link, navigate to it
    let href = e.target.getAttribute('href') || e.target.href;
    if (href) {
      // console.log('Link from event target:', href);
      // Link could be a full URL or a relative path, remove the base URL if present so it can be handled by react-router
      const baseUrl = window.location.origin;
      if (href.startsWith(baseUrl)) {
        href = href.replace(baseUrl, '');
      }
      // console.log('Navigating to link:', href);
      history.push(href);
      if (typeof onAfterLinkClick === 'function') {
        onAfterLinkClick(href);
      }
      return;
    }
    console.log('Link:', link);
    if (link) history.push(link);
    if (typeof onAfterLinkClick === 'function') {
      onAfterLinkClick(link);
    }
  };

  return (
    <div
      className={`flex flex-row w-full py-3 border-b border-b-pursuit-gray ${!isRead && 'cursor-pointer'} ${link &&
        'cursor-pointer'}`}
      // title={isRead ? `Notification read at ${notification.readAt}` : 'Click to mark as read'}
      onClick={onClick}>
      <div className={`flex flex-row w-full p-2 ${readClass}`}>
        <div className={`${customClasses} flex items-center justify-center w-20 h-20 mr-4 border border-pursuit-gray `}>
          {getIcon()}
        </div>

        <div className="flex flex-col flex-1 min-h-20">
          <p className="font-bold text-guardian-darkblue">
            {notification.attributes ? notification.attributes.customTitle || notification.title : notification.title}
          </p>
          {/* <p className="mb-1 text-sm text-pursuit-gray">{notification.message}</p> */}
          <span className="mb-1 text-sm text-pursuit-gray" dangerouslySetInnerHTML={{ __html: content }} />
          <p
            className="w-full mt-auto text-xs text-right text-gray-300 cursor-pointer"
            onClick={async e => {
              e.stopPropagation();
              setLoading(true);
              // console.log('Toggling notification read state:', notification.id);
              if (!!isRead) {
                await markUnread();
                // console.log('Notification marked as unread:', update);
                // setNotification(update);
              } else {
                await markRead();
              }
              setLoading(false);
              // unRead();
              return false;
            }}>
            <NotificationToggle loading={loading} notificationId={notification.id} readAt={notification.readAt} />
            &nbsp;
            {/* {isRead ? readIcon : unreadIcon} */}
            <span title={`Received at ${notification.createdAt}`}>{getNotificationTime()}</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotificationRow;
